const handleCartPattern = () => {
	const $cartPatternContainer = $('.cart__properties');

	if ($cartPatternContainer.length === 0) {
		return;
	}

	$cartPatternContainer.each(function() {
		const $this = $(this).find('div');
		const isPatternPropery = $this.text().toLowerCase().indexOf('pattern:') >= 0;

		if (! isPatternPropery) {
			return;
		}

		const patternName = $this.text().toLowerCase().replaceAll('pattern:','').replaceAll(' ', '-');

		$this.html('');

		$('.js-global-patterns [data-pattern="' + patternName + '"]').closest('.pattern').clone().appendTo($this);
	});
}

handleCartPattern();
